// Shaping of series for charts. Domain figures (energy balance) come from the backend; this only prepares display.

export interface TimedValue {
  t: number;
  v: number | null;
}

/**
 * Increments of a cumulative counter between consecutive points. A falling counter is a reset or a meter swap,
 * and a gap leaves the next increment unknown, so both give no value rather than a wrong one.
 */
export function counterIncrements(points: readonly TimedValue[]): TimedValue[] {
  const out: TimedValue[] = [];
  let previous: number | null = null;
  for (const p of points) {
    if (p.v === null) {
      out.push({ t: p.t, v: null });
      previous = null;
      continue;
    }
    out.push({
      t: p.t,
      v: previous === null || p.v < previous ? null : p.v - previous,
    });
    previous = p.v;
  }
  return out;
}
